<template>
  <div>
    <v-textarea ref="textarea" v-model="computedValue" :hide-details="hideDetails && (!rules || !rules.length)"
                :label="label" :rows="rows" :rules="rules" clear-icon="mdi-close-circle-outline" clearable dense
                outlined>
      <template v-if="$vuetify.breakpoint.smAndUp" v-slot:append>
        <div class="d-flex flex-column fill-height justify-space-between">
          <v-btn class="px-0" min-width="36" small style="font-size: 1.5em" text title="ایموجی"
                 @click="emojiModel = true">
            <div>🙂</div>
          </v-btn>
        </div>
      </template>
    </v-textarea>

    <v-btn v-if="$vuetify.breakpoint.xs" class="px-2" style="font-size: 1.5em" text title="ایموجی"
           @click="emojiModel = true">
      <div>🙂</div>
    </v-btn>

    <custom-popup v-model="emojiModel" :cons="cons" hide-confirm max-width="500">
      <emoji-selector :inputBox="$refs.textarea"/>
    </custom-popup>
  </div>
</template>

<script>
import EmojiSelector from "./emoji";

export default {
  name: "suggestText",

  components: {EmojiSelector},

  props: {
    rules: Array,
    value: String,
    label: String,
    hideDetails: {
      type: Boolean,
      default: true,
    },
    rows: {
      type: [String, Number],
      default: 5
    }
  },

  data() {
    return {
      emojiModel: false,
      cons: {
        title: 'انتخاب ایموجی'
      },
    }
  },

  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  // mounted() {
  //   const temp = this.value;
  //   this.$emit('input', 'salam');
  //
  //   this.$nextTick(() => {
  //     this.$emit('input', temp);
  //   });
  // }
}
</script>

<style scoped>
.v-input >>> .v-input__append-inner {
  margin: 0;
}
</style>